import { Injectable } from "@angular/core";
import { TokenService } from "@auth/token.service";
import { AuthenticationService } from "@auth/authentication.service";
import { canActivateGuard, ROLES } from "@shared/common";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

@Injectable({ providedIn: "root" })
export class RecepcionGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private tokenService: TokenService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return canActivateGuard(
      this.tokenService,
      this.authenticationService.currentUserValue,
      ROLES.RECEPCION
    );
  }
}
